// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__qmdpO h1","h2":"Heading_h2__OoAJS h2","h3":"Heading_h3__5I2Dd h3","h4":"Heading_h4__ZxpHm h4","h5":"Heading_h5__F5HFm h5","h6":"Heading_h6__yeSTR h6"};